import Button from './components/Button';

const Header = ({ onReset }) => {
  return (
    <div className="border-b border-gray-200 p-2 flex items-center justify-between">
      <h1 className="text-6xl">Mini Calendar Generator</h1>

      <Button
        label="Reset ..."
        variant="secondary"
        onClick={onReset}
      />
    </div>
  );
};

export default Header;